/*eslint-disable*/
import React, { useEffect, useState } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import { List, ListItem, withStyles } from "@material-ui/core";

import { getAsset } from "lib/api";

import footerStyle from "assets/jss/material-kit-react/components/footerStyle.jsx";

function Footer({ ...props }) {
  const [codeOfConduct, setCodeOfConduct] = useState(null);

  useEffect(() => {
    async function fetchData() {
      const response = await getAsset("5VInWZN4udC5p5ZtWt3pQ5");

      setCodeOfConduct(response);
    }

    fetchData();
  }, []);

  const { classes, whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  const aClasses = classNames({
    [classes.octomistLink]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a
                href={codeOfConduct?.file.url}
                className={classes.block}
                target="_blank"
                rel="noopener noreferrer"
              >
                {codeOfConduct?.title}
              </a>
            </ListItem>
          </List>
        </div>
        <span className={classes.right} style={{ fontSize: "12px" }}>
          &copy; {1900 + new Date().getYear()}{" "}
          <a
            href="https://www.octomist.com"
            className={aClasses}
            target="_blank"
            rel="noopener noreferrer"
          >
            <b style={{ fontSize: "14px" }}>Octomist</b>
          </a>
        </span>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  whiteFont: PropTypes.bool,
};

export default withStyles(footerStyle)(Footer);
